export default __webpack_public_path__ + "static/naming-convention-ccc3345a6cd1784675e0832ec3f44418.png";